import React from 'react';
import 'leaflet-ajax';
import './style.css';
import geoJsonData from './../../geojson/geojson.json';
import GoogleMap from 'google-map-react';
import { connect } from "react-redux";



class ToursMap extends React.Component {

  constructor(props){
    super(props);
  }


  computeTours(data, folder){
    if(data.data.length > 1){
      return [folder + "/" + data.data[0],folder + "/" + data.data[1]]
    }else{
      return [folder + "/" + data.data[0],folder + "/" + data.data[0]]
    }
  }


  renderMarkers = async (map, maps) => {
    var obj1 = {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Origin': 'https://www.360bilder.no',
      },
    }


    await fetch("https://www.360bilder.no/fv564/settings.php",obj1)
        .then(response => response.json())
        .then(async data => {
           let markers = data.data.features;
           
          var obj = {  
            method: 'GET',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Origin': 'https://www.360bilder.no',
            },
          }
          
          for await (var marker of markers){

            var folder = marker.properties.pos;
            var updatePosition = marker.properties.status;
            await fetch("https://www.360bilder.no/fv564/menu.php?folder=" + folder,obj)
                .then(response => response.json())
                .then(data => {
                  var computedFolder = folder;
                  var nMaker = new maps.Marker({
                    position: {lat: marker.geometry.coordinates[1], lng: marker.geometry.coordinates[0]},
                    map,
                    title: folder,
                    icon: {
                      url: (computedFolder == this.props.tourName) ?  "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png" : ((updatePosition == "1") ?  "http://maps.google.com/mapfiles/ms/icons/blue-dot.png" : "http://maps.google.com/mapfiles/ms/icons/red-dot.png")
                    }
                  });
                  var links = this.computeTours(data, folder);
                  nMaker.addListener("click", () => {
                    this.props.setTourName(computedFolder);
                    if(data.data.length != 1){
                      this.props.setUpper(links[0]); 
                      this.props.setBelow(links[1]);
                    }else{
                      this.props.setUpper(links[0]); 
                      this.props.setBelow(undefined);
                    }
                    this.props.setTours(data.data);
                  });
                }).catch(err=>{
                  console.log(err)
                }).finally(() => {
                  }
                );
          }
        }).catch(err=>{
          console.log(err)
        }).finally(() => {
            
          }
        );
    
    // let markers = geoJsonData.features;
    // map.data.loadGeoJson(
    //   "https://hawkeye.sk/react/geojson2.json"
    // );
  }

  shouldComponentUpdate(){
    this.forceUpdate();
  }

  

  render() {
    return (<div id="content" style={{ height: '100vh', width: '100%' }}>
      <GoogleMap
        key={this.props.tourName}
        bootstrapURLKeys={{ key: "AIzaSyBOSENJif6j2sPCMI57B_O69pVFwMEw5_8", v: "beta", libraries: "marker" }}
        center={[60.5240446,5.2415753]}
        zoom={12.62}
        onGoogleApiLoaded={({map, maps}) => this.renderMarkers(map, maps)}
        options={{
          fullscreenControl: false,
          zoomControl: false
        }}
      >
      </GoogleMap>
    </div>)
  }
}

const mapStateToProps = state => ({
  tourName : state.tourName,
});

const mapDispatchToProps = dispatch => ({
  setUpper: (tourWin) => dispatch({type: "update/upperWindow", tour: tourWin}),
  setBelow: (tourWin) => dispatch({type: "update/belowWindow", tour: tourWin}),
  setTours: (tours)   => dispatch({type: "update/tours",       tours: tours}),
  setTourName: (tourName)=> dispatch({type: "update/tourName", tourName: tourName}),
});

export default connect(mapStateToProps, mapDispatchToProps)(ToursMap);

